var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#5592D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3884 7.12507V14.4224L5.22563 10.8747C3.40313 9.80764 3.51901 9.14389 3.51901 7.7022L9.85444 11.3652V8.01889L11.3878 7.12451L11.3884 7.12507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.855 11.3653L3.51956 7.70169L9.68119 4.154C11.5037 3.11506 12.0246 3.54819 13.2975 4.26931L6.96206 7.93288L9.855 9.60575V11.3653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.96206 7.93285L13.2975 4.26929V11.3652C13.2975 13.4712 12.6613 13.7018 11.3884 14.423V7.1251L8.46563 8.79741L6.9615 7.93229L6.96206 7.93285Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaid);
export default __webpack_public_path__ + "static/media/maid.3ddef870f3bbb126d7e95c24e0830553.svg";
export { ForwardRef as ReactComponent };